import PageHeaderText from 'components/base/page-header-text';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import PreviewCategoryDetails from './preview-details';
import EditCategoryDetails from './edit-details';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { Breadcrumbs, ToastMessage } from '@cokitchen/cokitchen-components';
import { GiftCardCategoryType } from 'utils/types';

const GiftcardCategoryDetailsPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [categoryDetails, setCategoryDetails] = useState<GiftCardCategoryType>();
  const [editing, setEditing] = useState(false);

  const getCategoryDetails = async () => {
    try {
      setLoading(true);
      const res = await apiService.get(`vouchers/voucher-categories/${id}`, {
        isInternal: true,
        baseURL: process.env.REACT_APP_ORDER_API
      });
      if (res?.data) {
        setCategoryDetails(res?.data);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategoryDetails();
  }, [id]);

  useEffect(() => {
    if (categoryDetails && searchParams.get('editing') === 'true') {
      setEditing(true);
      searchParams.delete('editing');
      setSearchParams(searchParams);
    }
  }, [categoryDetails]);

  const breadCrumbs = [
    { name: 'Manage giftcard categories', path: ROUTE_KEYS.GIFTCARD_CATEGORIES },
    {
      name: `${categoryDetails?.name}`,
      path: ''
    }
  ];

  if (loading) {
    return <p className='flex justify-center items-center min-h-full mt-20'>Loading...</p>;
  }

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadCrumbs} />
      <PageHeaderText
        title={
          editing ? 'Edit category ' : `${categoryDetails?.emoji ?? ''}${categoryDetails?.name}`
        }
        description='Update Christmas category here'>
        {!editing && (
          <button
            onClick={() => setEditing(true)}
            className='w-[86px] h-[40px] border border-[#E7E8E9] shadow-sm rounded-lg text-sm text-[#5C5F64] font-medium'>
            Edit
          </button>
        )}
      </PageHeaderText>
      {editing ? (
        <EditCategoryDetails data={categoryDetails} backLink={() => setEditing(false)} />
      ) : (
        <PreviewCategoryDetails data={categoryDetails} />
      )}
    </div>
  );
};

export default GiftcardCategoryDetailsPage;
